<div class="zag-app-header__container">
  <div class="zag-app-header__branding">
    @if (logo()) {
    <button type="button" class="zag-app-header__logo-button" (click)="onLogoClick()">
      <img class="zag-app-header__logo" [src]="logo()" [alt]="logoAlt()" />
    </button>
    }

    <h1 class="zag-app-header__title">{{ title() }}</h1>
  </div>
  <div class="zag-app-header__controls">
    <ng-content></ng-content>
  </div>
</div>
